<mat-checkbox
  (change)="onChange()"
  [formControl]="control"
  [ngClass]="centerAligned ? 'align-center wrap bdg-checkbox' : 'wrap bdg-checkbox'"
  ><bdg-label *ngIf="label" type="body-1"> {{ label }} </bdg-label>
  <ng-content></ng-content>
</mat-checkbox>
<div class="" *ngIf="control.invalid && (control.dirty || control.touched)">
  <div class="ml-1">
    <mat-error class="mat-caption d-inline" *ngIf="errorMessage">{{ errorMessage }}</mat-error>
    <mat-icon
      *ngIf="control.invalid && (control.dirty || control.touched)"
      matSuffix
      class="mat-icon notranslate mat-error material-icons radio-error-icon checkbox-icon-error"
      >error</mat-icon
    >
  </div>
</div>
